import { render } from "./GeneralCard.vue?vue&type=template&id=43929996&lang=pug"
import script from "./GeneralCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralCard.vue?vue&type=script&setup=true&lang=js"

import "./GeneralCard.vue?vue&type=style&index=0&id=43929996&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__